const INFO = {
	main: {
		title: "Aayush Portfolio React JS",
		name: "Aayush",
		email: "soniaayush3@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/Aayush-Cloud?tab=repositories",
		linkedin: "https://www.linkedin.com/in/aayush-soni-9a17051a2/",
		// instagram: "https://instagram.com/",
		// stackoverflow: "https://stackoverflow.com/",
		// facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Full-stack web and mobile app developer.",
		description:
			"I am a Full-stack web and mobile app developer with expertise in Javascript. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies. I enjoy solving complex problems and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
	},

	about: {
		title: "I’m Aayush. I live in Stuttgart, Germany, where I design the beautiful and build robust Web Solutions.",
		description:
			"I've worked for a variety of companies and on a variety of projects over the years and I'm proud of the progress I've made. Some of these projects are for big giants and some for small startups. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Industrial Controller",
			description:
				"Effortlessly manage industrial hardware and software with our cutting-edge application, built using Vue 3.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/Aayush-Cloud/vue3_slm",
		},

		

		{
			title: "My Library",
			description:
				"A complete library management system that allows you to manage your books, authors, and categories.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/Aayush-Cloud/Library-Management-System-React-Native-Frontend",
		},	
	],
};

export default INFO;
